import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";

const VideoTutorials = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    return (
        <>
            <div className="main_title">
                <h1>Video Tutorials View</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/admin-support")}>
                        Admin Support Management
                    </button>
                    - Video Tutorials
                </p>
            </div>
            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                </div>

                <div className="video-grid">

                    {[
                        { title: "How to Set Up Your Store", duration: "3:47" },
                        { title: "Managing Your Products", duration: "5:12" },
                        { title: "Understanding Payments", duration: "6:28" },
                        { title: "Creating Promotions", duration: "7:45" },
                        { title: "Creating Promotions", duration: "6:28" },
                        { title: "Tips for AI Tools", duration: "5:10" },
                    ].map((item, i) => (
                        <div className="video-card" key={i}>
                            <div className="thumb" >
                                <span className="play-btn">▶</span>
                                <span className="duration">{item.duration}</span>
                            </div>

                            <h4>{item.title}</h4>
                        </div>
                    ))}

                </div>

            </div>

        </>
    );
}
export default VideoTutorials;